import type { QuoteFile } from 'paintscout'
import shuffle from 'lodash/shuffle'
import {
  interiorExteriorForCategory,
  type PhotoCategory
} from '../../../builder/options/presentation/util/photo-categories'

// not using version (v) in urls so
// if replacing an image at the same publicId, set invalidate to true when uploading
// see: https://cloudinary.com/documentation/advanced_url_delivery_options#asset_versions
const defaultPublicId = '_static/placeholders/grey'

/**
 * Hand-tagged from the slug (ENG-1857 / #23702) — this is a small, fixed, hand-maintained list, so
 * a one-time vision-classification call isn't worth it. None of these depict a specific surface
 * (siding, cabinets, etc.), so the exterior/interior painting shots bucket into the generic
 * `*-other` categories and everything else (process/people shots) into `people-process`.
 */
const PHOTO_CATEGORY_BY_SLUG: Partial<Record<string, PhotoCategory>> = {
  'prep-exterior': 'exterior-other',
  'paint-exterior': 'exterior-other',
  'paint-interior': 'interior-other',
  measure: 'people-process',
  'color-consult': 'people-process',
  'present-estimate': 'people-process',
  prepping: 'people-process',
  spraying: 'people-process',
  'before-after': 'people-process',
  team: 'people-process',
  van: 'people-process',
  'yard-sign': 'people-process'
}

function s3PainterPhoto(slug: string): QuoteFile {
  const photoCategory = PHOTO_CATEGORY_BY_SLUG[slug]
  return {
    src: `https://paintscout.s3.us-east-1.amazonaws.com/presentations/${slug}.png`,
    format: 'png',
    // Without this the record is `src` + `s3PublicKey` with no `type`, which is the shape that
    // used to crash the shared FilePreview once it reached an Awards/Documents row (#23950).
    type: 'image/png',
    s3PublicKey: `presentations/${slug}`,
    cloudinaryPublicId: defaultPublicId,
    width: 1536,
    height: 1024,
    visibility: 'visible',
    photoCategory,
    interiorExterior: interiorExteriorForCategory(photoCategory)
  }
}

const s3PainterPhotos: QuoteFile[] = [
  'measure',
  'color-consult',
  'present-estimate',
  'prep-exterior',
  'paint-exterior',
  'paint-interior',
  'prepping',
  'spraying',
  'before-after',
  'team',
  'van',
  'yard-sign'
].map(s3PainterPhoto)

export function getPrefabImages(): QuoteFile[] {
  return shuffle(s3PainterPhotos)
}
